<template>
  <div>
    <div class="card" v-loading="working" element-loading-spinner="qc-spinner">
      <button v-if="!self" @click="$emit('close')" class="btn btn-simple btn-info btn-icon pull-right" style="position: relative; z-index: 4"><i class="fa fa-times"></i></button> 
      <div class="card-header">
        <h4 class="card-title">{{title}}</h4>
        <p v-if="description" class="category">{{description}}</p>
      </div>
      <div class="card-content">
        <div class="form-horizontal" data-vv-scope="user-form">
          <dynamic-input label="Username" :readOnly="true" :value="user.username" />
          <dynamic-input label="First name" name="firstname" :validations="{required: true}" v-model="user.firstname" />
          <dynamic-input label="Last name" name="lastname" :validations="{required: true}" v-model="user.lastname" />
          <dynamic-input v-if="!$store.state.isIndividual" label="Phone" name="phone" :validations="{required: true}" v-model="user.phone" />
          <div v-if="self && this.$store.state.currency == 'USD'" class="form-group">
            <label class="col-sm-2 control-label">Currency</label>
            <div class="col-sm-10">
              <p class="form-control-static">USD ($)</p>
            </div>
          </div>
          <div v-if="self && this.$store.state.currency == 'EUR'" class="form-group">
            <label class="col-sm-2 control-label">Currency</label>
            <div class="col-sm-10">
              <p class="form-control-static">EUR (€)</p>
            </div>
          </div>
          <div v-if="self && this.$store.state.currency == 'AUD'" class="form-group">
            <label class="col-sm-2 control-label">Currency</label>
            <div class="col-sm-10">
              <p class="form-control-static">AUD ($)</p>
            </div>
          </div>
          <div v-if="self && !$store.state.isIndividual" class="form-group">
            <label class="col-sm-2 control-label">Notifications</label>
            <div class="col-sm-10">
              <p class="form-control-static"><p-switch v-model="user.notifications" on-text="Yes" off-text="No"></p-switch></p>
              <span class="help-block">Recieve notification emails when regular system events occur. Critical system events will continue to be notified via email.</span>
            </div>
          </div>
          <div v-if="self" class="form-group">
            <label class="col-sm-2 control-label">Marketing</label>
            <div class="col-sm-10">
              <p class="form-control-static"><p-switch v-model="user.marketing" on-text="Yes" off-text="No"></p-switch></p>
              <span class="help-block">Qualification Check may email the above address from time to time with updates and promotions.</span>
            </div>
          </div>
          <div v-if="!self" class="form-group">
            <label class="col-sm-2 control-label">Admin</label>
            <div class="col-sm-10">
              <p class="form-control-static"><p-switch v-model="user.admin" on-text="Yes" off-text="No"></p-switch></p>
              <span class="help-block">Admin users will be able to view and change company details as well as add more users.</span>
            </div>
          </div>
          <div v-if="!self && assignableCustomRoles && assignableCustomRoles.length > 0" class="form-group">
            <label class="col-sm-2 control-label">{{customRolesLabel}}</label>
            <div class="col-sm-10">
              <p class="form-control-static">
                <el-select multiple
                  v-model="newCustomRoles"
                  :clearable="true"
                  placeholder="None"
                  style="z-index: 1000 !important;">
                  <el-option v-for="role in assignableCustomRoles" :key="role" :value="role" :label="role" />
                </el-select>
              </p>
              <span class="help-block">Assign a {{customRolesLabel}} to manage a users permissions.</span>
            </div>
          </div>
          <div v-if="self" class="form-group">
            <label class="col-sm-2 control-label">Password</label>
            <div class="col-sm-10">
              <p class="form-control-static"><button @click="updatePassword" class="btn btn-fill btn-wd btn-default"><span class="btn-label"><i class="fa fa-refresh"></i></span>&nbsp;Change</button></p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="saveUser" class="btn btn-fill btn-wd pull-right" v-bind:disabled="!savable" v-bind:class="{'btn-disabled': !savable}"><span class="btn-label"><i class="fa fa-floppy-o"></i></span>&nbsp;Save</button>
          <button v-if="!self" @click="deleteUser" class="btn btn-fill btn-wd"><span class="btn-label"><i class="fa fa-trash"></i></span>&nbsp;Delete</button>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import PSwitch from 'src/components/Switch.vue'

  import UpdatePasswordCard from './UpdatePasswordCard'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'

  export default {
    name: 'account-card',
    components: {
      DynamicInput,
      PSwitch,
      UpdatePasswordCard
    },
    props: {
      title: {type: String, default: "Account" },
      description: {type: String, default: "Your account details and settings"},
      user: {type: Object, default: {}},
      self: {type: Boolean, default: true},
      customRolesLabel: {type: String, default: "Roles"},
      newCustomRoles: {type: Array, default: function(){return this.user.customRoles}},
      assignableCustomRoles: {type: Array, default: function(){return []}}
    },
    data () {
      return {
        saving: false
      }
    },
    computed: {
      working() {
        return !this.user.username || this.saving
      },
      savable() {
        return !this.saving && !this.$validator.errors.any()
      }
    },
    methods: {
      updatePassword() {
        this.$modal.show(UpdatePasswordCard,
          {
            username: this.user.username
          },
          {
            saved: () => {
                this.$modal.close()
              },
            close: () => {
              this.$modal.close()
            }
          }
        )
      },
      saveUser() {
        this.$validator.validateAll().then(result => {
          if(result) {
            this.saving = true
            this.doSave()
              .then(response => {
                this.$snotify.success(this.title + " updated", "Success")
                this.$emit('saved')
                this.saving = false
              })
              .catch(error => {
                console.log(error)
                this.saving = false
              })
          }
        })
      },
      deleteUser() {
        this.$emit('deleteUser')
      },
      doSave() {
        var updateRequest = {
          username: this.user.username,
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          phone: this.user.phone,
          marketing: this.user.marketing,
          notifications: this.user.notifications,
        }
        if(!this.self) {
          updateRequest.admin = this.user.admin
          updateRequest.customRoles = this.newCustomRoles
        }
        return this.self ? this.$api.updateAccount(updateRequest) : this.$api.updateUser(updateRequest)
      }
    }
  }
</script>